import React from 'react';

import {Button} from 'antd';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import GavelIcon from '@mui/icons-material/Gavel';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AddCardIcon from '@mui/icons-material/AddCard';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import './roles.scss';
import {PlusOutlined} from '@ant-design/icons';
import { ROUTES } from '../../utils/ROUTES';
import { useNavigate } from 'react-router-dom';

export interface FacilitateItem {
	icon: React.ElementType;
	text: string;
}

// Fixed benefits array for all roles
const facilitateItems: FacilitateItem[] = [
	{
		icon: FastForwardOutlinedIcon,
		text: 'Hire within 24hrs',
	},
	{
		icon: AddCardIcon,
		text: 'NO CC needed to start',
	},
	{
		icon: GavelIcon,
		text: 'AI summaries to support screening process',
	},
	{
		icon: AccountBalanceWalletIcon,
		text: 'Hire staff direct',
	},
	{
		icon: EditNoteOutlinedIcon,
		text: 'Screen the candidates the way you want',
	},
	{
		icon: CheckCircleIcon,
		text: 'Quality candidate database',
	},
];

export default function WhyCompaniesChooseUs() {
	// Use the custom array if provided, otherwise use the default one
	const displayArray = facilitateItems;
	const navigate = useNavigate();
	return (
		<div>
			<div className="px-4 text-left py-14 md:py-24 bg-backgroundGreyBlue">
				<div className="flex flex-col flex-wrap justify-center gap-4 max-w-[1100px] mx-auto">
					<div className="left-side mx-auto text-center">
						<h4 className="text-charcoal font-light text-base">Why companies choose us</h4>
						<p className="text-deepBlue font-normal text-xl sm:text-2xl">They choose us because we the bes tin the entire west world</p>
					</div>
					<div className="flex flex-wrap gap-3 my-2">
						{displayArray.map((item, index) => (
							<div className="flex-1 flex flex-col p-2 rounded-lg shadow-border-chill-background bg-white min-w-[300px] gap-3  h-fit min-h-fit" key={index}>
								<div className="flex items-center gap-4">
									<item.icon className=" box-content p-3 rounded-md bg-lightblue/40 text-deepBlue" />
									<p className="text-sm font-normal text-charcoal">{item.text}</p>
								</div>
							</div>
						))}
					</div>
					<Button className="w-fit  mx-auto " type="primary" icon={<PlusOutlined />} onClick={() => navigate(ROUTES.POST_JOB)}>
						Post a job
					</Button>
				</div>
			</div>
			{/* <RoleTypes /> */}
		</div>
	);
}
